// types
import type { AdditionalSelectors } from '../types';
import type { HostActions } from '../types/HostActions';

// store
import * as actionCreators from './actionCreators';
import { MiddlewareManager } from './middlewareManager';
import { Selectors } from './selectors';

export const recentDealsCreators = actionCreators;
export let recentDealsSelectors: Selectors;
export let middlewareMgr: MiddlewareManager;

export const init = (
    appName: string,
    additionalSelectors: AdditionalSelectors,
    hostActions: HostActions
): {
    selectors: Selectors;
    middlewareMgr: MiddlewareManager;
} => {
    recentDealsSelectors = new Selectors(appName, additionalSelectors);
    middlewareMgr = new MiddlewareManager(recentDealsSelectors, hostActions);

    return {
        selectors: recentDealsSelectors,
        middlewareMgr
    };
};
